import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { ITicketParameter, TicketParameter, ITicketListingViewModel } from '../../../../models/ticket';
import { StateTypes, ActivityStatus, TicketTypes } from '../../../../common/enums';
import { namespace } from 'vuex-class';
//@ts-ignore
import { TICKET_MODULE_NAMESPACE, } from '@/store/ticket';
//@ts-ignore
import { BLOCK_MODULE_NAMESPACE, BLOCK_APARTMENT_SIDEBAR_GET_TICKETS } from '@/store/block';
import { TICKET_SET_APPOINTMENT_BY_FIELD, TICKET_RESET, TICKET_RECORD, TICKET_SET_TICKETS_PARAMETER } from '../../../../store/ticket';
import { USER_MODULE_NAMESPACE } from '../../../../store/user/user-types.store';
import { TENANT_MODULE_NAMESPACE } from '../../../../store/tenant';
import { ITicket } from '../../../../models/ticket';
import { IGenericDefaultSelectOption, GenericDefaultSelectOption } from '../../../../models/generic';
import { OWNER_MODULE_NAMESPACE } from '../../../../store/owner';
import { AUTHORIZATION_FUNCTIONALITIES, AUTHORIZATION_MODULE_NAMESPACE } from '../../../../store/authorization';
import { BLOCK_LOADERS, BLOCK_SET_LOADER_STATE } from '../../../../store/block';

const TicketStore = namespace(TICKET_MODULE_NAMESPACE)
const BlockStore = namespace(BLOCK_MODULE_NAMESPACE)
const UserStore = namespace(USER_MODULE_NAMESPACE)
const TenantStore = namespace(TENANT_MODULE_NAMESPACE)
const OwnerStore = namespace(OWNER_MODULE_NAMESPACE)
const AuthorizationStore = namespace(AUTHORIZATION_MODULE_NAMESPACE)
@Component({
  components: {
    'list-item': async () => import('@/containers/ticket/components/ticket-list-item/TicketListItem.vue'),
    'ticket-modal': async () => import('@/containers/ticket/components/ticket-modal-vertical/TicketModalVertical.vue'),
    'no-record': async () => import('@/components/empty/Empty.vue'),
    'ticket-list-loader': async () => import('../../../ticket/loaders/ticket-list-loader/TicketListLoader.vue')
  }
})
class BlockApartmentsTickets extends Vue {

  dtAcitivityStatus: ActivityStatus
  dtCreateAnother: boolean;
  dtIsRecording: boolean;
  dtTicketModalVisible: boolean;
  dtTickets: ITicketListingViewModel[];
  dtAttachments: any[];
  dtPreviousTicket: { ticketId: number, channelId: number } | null;
  dtTabs: string[]
  dtTab: number;
  _clearTimeout: any;
  @Prop({ default: () => new TicketParameter({ state: [StateTypes.InProgress] }) })
  parameter: ITicketParameter;

  @BlockStore.Getter currentBlockId: number;
  @BlockStore.Getter blockApartmentInProcessTickets: ITicketListingViewModel[];
  @TenantStore.Getter currentTenant: any;
  @OwnerStore.Getter currentOwner: any;
  @UserStore.Getter userInfo: { id: number, type: string } | any
  @BlockStore.Getter loaders: Map<string,boolean>

  @BlockStore.Action(BLOCK_APARTMENT_SIDEBAR_GET_TICKETS)
  storeGetTickets: (payload: {
    ticketParameter: ITicketParameter,
    storeKey?: string
  }) => Promise<ITicketListingViewModel[]>
  @TicketStore.Mutation(TICKET_SET_APPOINTMENT_BY_FIELD)
  storeAssignValueForTicket: (payload: { [key: string]: any }) => void;
  @TicketStore.Action(TICKET_RESET)
  storeResetTicket: () => void;
  @TicketStore.Action(TICKET_RECORD)
  storeRecordTicket: (payload: { attachments?: any[], keepAlive?: boolean }) => any | Promise<any>
  @TicketStore.Mutation(TICKET_SET_TICKETS_PARAMETER)
  storeResetParam: (payload: ITicketParameter) => void;


  @AuthorizationStore.Action(AUTHORIZATION_FUNCTIONALITIES)
  storeGetFunctionalities: (moduleName: string) => Promise<any>;

  @BlockStore.Mutation(BLOCK_SET_LOADER_STATE)
  storeSetBlockLoaderState: (payload?: { key: string, value: boolean }) => void

  dtTicketParameter: ITicketParameter;
  /**
   *
   */
  constructor() {
    super();
    this.dtTickets = []
    this.dtCreateAnother = false;
    this.dtIsRecording = false;
    this.dtTicketModalVisible = false;
    this.dtAttachments = [];
    this.dtAcitivityStatus = ActivityStatus.NoActivity;
    this.dtPreviousTicket = null;
    this.dtTabs = [
      'basicSearch'
    ]
    this.dtTab= null
    this.dtTicketParameter = new TicketParameter({
      state: [StateTypes.Open, StateTypes.InProgress, StateTypes.ReOpen],
      $limit: 20,
      apartment: null,
      typeValue: '',
      typeKey: 'apartment'
    });
  }

  get lblSetting(): { [prop: string]: string } {
    return {
      ...require('@/locales/block').default,
      ...require('@/locales/ticket').default,
      ...require('@/locales/generic-labels').default
    }
  }

  get blockId(): number[] {
    return [Number(this.$route.params.id)]
  }

  get apartmentId(): number {
    return Number(this.$route.params.cid);
  }
  get ticketPameter(): ITicketParameter {
    return {
      ...this.dtTicketParameter,
      block: [Number(this.$route.params.id)],
      typeValue: this.$route.params.cid
    };
  }
  get isLoading(): boolean {
    return this.dtAcitivityStatus === ActivityStatus.Loading;
  }
  get coStates(): IGenericDefaultSelectOption<string>[] {
    return [
      StateTypes.Open,
      StateTypes.InProgress,
      StateTypes.ReOpen,
      StateTypes.Close
    ].map(type => new GenericDefaultSelectOption<string>(this.$t(this.lblSetting.lblState[type]).toString(), type));
  }
  get fkTicketState(): string[] | number[] {
    return this.dtTicketParameter.state
  }
  set fkTicketState(value: string[] | number[]) {
    this.dtTicketParameter.state = value;
  }

  get currentEntity() {

    if (this.$route.fullPath.indexOf('tenant') > -1) {
      return this.currentTenant
    }
    else if (this.$route.fullPath.indexOf('owner') > -1) {
      return this.currentOwner
    }
    else {
      return {
        apartments: []
      }
    }

  }
  get coLoader() : boolean {
    return this.loaders.get(BLOCK_LOADERS.TICKETS)
  }
  mounted() {

    this.$watch('$route.params', () => {
      this.dtTickets = [];
      if (this.$route.fullPath.indexOf('apartment') > -1) {
        this.handleLoadTickets();
      }
    })
    this.$watch('currentEntity.apartments', (value) => {
      setTimeout(() => {
        this.handleLoadTickets()
      }, 500);
    })
    if (this.$route.fullPath.indexOf('apartment') > -1) {
      this.handleLoadTickets();
    }

  }
  beforeDestroy(){
    const param = new TicketParameter({ key: null, block:  null, apartment: [] });
    this.storeResetParam(param);
  }

  private async handleLoadTickets(debounce?: number) {
    if (this.currentEntity.id === undefined && this.$route.fullPath.indexOf('apartment') === -1) return;
    clearTimeout(this._clearTimeout)
    this.storeSetBlockLoaderState({ key: BLOCK_LOADERS.TICKETS, value: true })
    this._clearTimeout = setTimeout(async () => {

      this.dtAcitivityStatus = ActivityStatus.Loading;

      if (this.$route.fullPath.indexOf('owner') > -1) {
        this.dtTicketParameter.typeKey = 'owner';
        this.dtTicketParameter.apartment = null;
      } else if (this.$route.fullPath.indexOf('apartment') > -1) {
        this.dtTicketParameter.typeKey = 'apartment';
        this.dtTicketParameter['apartment'] = this.apartmentId;
      }
      else if (this.$route.fullPath.indexOf('tenant') > -1) {
        this.dtTicketParameter.typeKey = 'tenant';
        this.dtTicketParameter.apartment = null;
      }

      await this.storeGetTickets({
        ticketParameter: this.ticketPameter,
        storeKey: 'blockApartmentInProcessTickets'
      })
        .then(response => {
          this.dtTickets = response;
          setTimeout(() => {
            this.dtAcitivityStatus = ActivityStatus.Loaded;
          }, 500);
        })
        .catch(err => {
          this.dtTickets = []
          this.dtAcitivityStatus = ActivityStatus.LoadFailed;
        })
        .finally(()=> this.storeSetBlockLoaderState({ key: BLOCK_LOADERS.TICKETS, value: false }) )
    }, debounce || 0);

  }
  get maxWidth(): string {
    return `${document.body.clientWidth * 0.80}px`
  }
  async handleCreateTicket() {
    const ticketCreateLocalStorage = localStorage.getItem('ticket_create')
    if (ticketCreateLocalStorage === null) {
      await this.storeGetFunctionalities('ticket_create')
        .then(response => {
          if (this.$route.meta) {
            Object.keys(response).forEach(key => this.$route.meta[key] = true);
          }
          this.dtTicketModalVisible = true;
          this.handleAssignTicketData();
        })
        .catch(error => console.log(error));
    } else {
      const funcs = JSON.parse(ticketCreateLocalStorage);
      if (this.$route.meta) {
        Object.keys(funcs).forEach(key => this.$route.meta[key] = true);
      }
      this.dtTicketModalVisible = true;
      this.handleAssignTicketData();
    }

  }

  private handleAssignTicketData() {
      const ticket: ITicket = {
        declarant: this.userInfo.id,
        fk_ticket_block: parseInt(this.$route.params.id),
        fk_ticket_apartment: parseInt(this.$route.params.cid),
        apartments: [parseInt(this.$route.params.cid)],
        pb_type: TicketTypes.Private
      };

      if (this.$route.path.indexOf('tenant') > -1) {
        ticket.tenants = Number(this.$route.params.cid)
      }

      this.storeAssignValueForTicket(ticket);
  }

  get createButtonVisible(): boolean {
    return this.$route.meta.create_ticket
  }
  handleSave() {
    this.dtIsRecording = true;
    this.storeRecordTicket({ attachments: this.dtAttachments, keepAlive: this.dtCreateAnother })
      .then((createdTicket: ITicket) => {
        this.dtIsRecording = false;
        this.dtAttachments = [];
        if (this.dtCreateAnother === false) {
          this.dtTicketModalVisible = false;
          this.handleRedirectTo(createdTicket.id, createdTicket.channel_public)
        } else {
          this.dtPreviousTicket = { ticketId: createdTicket.id, channelId: createdTicket.channel_public }
        }
      })
      .catch(error => {
        this.dtIsRecording = false;
        throw error;
      })
  }
  handleRedirectTo(ticketId: number, channelId: number) {
    setTimeout(() => this.$router.push({
      path: `/ticket/${ticketId}/channel/${channelId}`, params: {
        id: ticketId.toString(), cid: channelId.toString()
      }
    }), 100);
  }
  handleBeforeModalClose() {
    setTimeout(() => {
      this.storeResetTicket();
      if (this.dtPreviousTicket !== null) {
        this.handleRedirectTo(this.dtPreviousTicket.ticketId, this.dtPreviousTicket.channelId);
      }
    }, 300);
  }


  @Watch('dtTicketParameter.state')
  handleChangeState() {
    this.handleLoadTickets(1500)
  }
}

export default BlockApartmentsTickets;



// WEBPACK FOOTER //
// ./src/containers/block/components/block-tickets/index.ts